.mf-create-service-case {
  display: block;
}

.mf-create-service-case__button-group {
  display: flex;
  gap: 0 10px;
  /* justify-content: center; */
}

mf-create-service-case ux-select {
  width: 100%;
}
